module.exports = __webpack_public_path__ + "static/Autospinn 1.f8275a69.svg";